import * as React from "react";

import { InteractiveSearchFormProps, InteractiveSearchRequestParams, InteractiveSearchResponse, InteractiveSearchRequest } from "./Definitions";
import { requestInteractiveSearchApi } from "./Utils/requestInteractiveSearchApi";

import { Search, Paging } from "./Components";

import styles from "./InteractiveSearch.css";

export const InteractiveSearchForm = (props: InteractiveSearchFormProps): JSX.Element => {
    const isInitialized = React.useRef(false);
    const $interactiveSearchResults = React.useRef<HTMLDivElement>(null);
    const [isFetching, setIsFetching] = React.useState(false);

    // Request
    const [requestParams, setRequestParams] = React.useState<InteractiveSearchRequestParams>({
        locale: props.language,
        searchTerm: props.searchTerm,
        page: 1
    });

    const requestInteractiveSearch = React.useRef<InteractiveSearchRequest>(requestInteractiveSearchApi(props.endpointUri));

    // Response
    const [responseData, setResponseData] = React.useState<InteractiveSearchResponse|null>(null);

    //
    React.useEffect(() => {
        let isActive = true;

        (async () => {
            setIsFetching(true)
            const response = await requestInteractiveSearch.current(requestParams);

            if (isActive) {
                isInitialized.current = true;
                setResponseData(response);
                setIsFetching(false);
            }
        })();

        return () => {
            isActive = false;
        }

    }, [requestParams]);

    const onUpdateInteractiveSearchParams = (update: Partial<InteractiveSearchRequestParams>) =>
        setRequestParams(state => ({
            ...state,
            ...update,
            page: update.page ?? 1
        }));

    return (
        isInitialized.current && responseData
        ? (
            <div>
                {/* Suche */}
                <div>
                    <Search
                        name={props.searchTerm ?? ""}
                        onClick={onUpdateInteractiveSearchParams}
                    />
                </div>

                {/* Ergebnisse */}
                <div
                    ref={$interactiveSearchResults}
                >
                    {
                        responseData?.results.map(result => (
                            <div
                                key={result.identifier}
                                dangerouslySetInnerHTML={{__html: result.content}}
                            >
                            </div>
                        ))
                    }
                    {
                        responseData.totalNumberOfResults === 0
                            ? <div>Keine Ergebnisse gefunden</div>
                            : null
                    }
                </div>

                {/* Paginierung */}
                {
                    responseData.numberOfPages > 1
                        ? (
                            <div>
                                <Paging
                                    currentPage={requestParams.page}
                                    numberOfPages={responseData.numberOfPages}
                                    onChange={onUpdateInteractiveSearchParams}
                                />
                            </div>
                        )
                        : null
                }
            </div>
        ) : (
            <div>
                ... Initialisiere Suche ...
            </div>
        )
    );
}
